var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroPic3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_173",
    "data-name": "Group 173",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.866,
    height: 69.748,
    viewBox: "0 0 46.866 69.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 46.866,
    height: 69.748,
    fill: "#2c3584"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M37.536,27.168C37.849,15.625,39.1.736,23.432,0,7.764.734,9.014,15.636,9.329,27.168c-18,12.382-8.142,43.345,14.1,42.566,22.24.778,32.1-30.188,14.1-42.566M13.144,14.1C13.389.581,33.479.587,33.721,14.1V24.846a23.783,23.783,0,0,0-20.577,0ZM23.432,65.919c-26.034-.467-26.03-39.157,0-39.62,26.034.467,26.03,39.157,0,39.62",
    transform: "translate(0 0)",
    fill: "#2c3584"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M45.41,74.2c-1.852-12.156-18.134-1.667-7.872,5.043v9.342a2.318,2.318,0,0,0,4.636,0V79.247A5.55,5.55,0,0,0,45.41,74.2",
    transform: "translate(-16.424 -32.982)",
    fill: "#2c3584"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPic3);
export default __webpack_public_path__ + "static/media/hero_pic3.40d51e009860bea6a4c279579b7c05be.svg";
export { ForwardRef as ReactComponent };